import React, { ChangeEvent, FC } from "react";

import { useTypedSelector } from "@hooks/useTypedSelector";
import FlexLine from "../../../components/elements/flexLine/FlexLine";
import Container from "../../../components/elements/container/Container";
import Sticker from "../../../components/elements/sticker/Sticker";

import { Align, ApiSelect, TextType, Width } from "@baseTypes/baseType";
import Tx from "../../../types/naming";
import st from './expenses.module.scss';

import PlanFact from "./planfact";
import ExpensesByArticles from "@pages/dashboard/expenses/articles";
import {
    CropSelectorProps,
    stickerLoadingWithCrop
} from "../phases";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import {Switcher, Type as T} from "@infobis/ui-styles-utils";
import { ExpensesState } from "../../../store/reducers/dashboard/expenses/types";
import { identity } from "fp-ts/es6/function";
import { useExpensesChartActions } from "@hooks/useActions";
import { Empty } from "./empty";
import { array } from "fp-ts";

interface ExpensesDashboardProps extends CropSelectorProps {
}

const expensesSelector : ApiSelect<ExpensesState> = createSelector((state: RootState) => state.dashExpenses,
    identity<ExpensesState>
)

const ExpensesDashboard: FC<ExpensesDashboardProps> = (props) => {
  let { data, expensesByArticles } = useTypedSelector((state) => state.dashExpenses);
  let { toggleExpensesByArticles } = useExpensesChartActions();

  const { selected } = useTypedSelector(state => state.cropSelector);

  const onExpensesByArticlesCheckboxChange = (v: ChangeEvent<HTMLInputElement>) =>
      toggleExpensesByArticles({ enabled : v.target.checked })
  const renderBody = () => <><FlexLine align={Align.SpaceBetween}>
      <FlexLine width={Width.Fit} textType={TextType.Header}>
          <span className={st.title}>{Tx.Expenses}</span>
      </FlexLine>
      <FlexLine width={Width.Fit} textType={TextType.Text}>
          <Switcher
              size={T.Size.SMALL}
              checked={expensesByArticles}
              onChange={onExpensesByArticlesCheckboxChange}
          />
          <span className={st.switch_label}>{Tx.ExpensesByArticle}</span>
      </FlexLine>
  </FlexLine>
      <Container>
          {expensesByArticles ?
              <ExpensesByArticles listOfExpensesForExpensesDash={data}/> :
              <PlanFact listOfExpensesForExpensesDash={data}/>
          }
      </Container></>
  return (
    <Sticker>
        {data.length > 0 && selected && !array.isEmpty(selected) ? renderBody() : <Empty />}
    </Sticker>
  );
};

export default stickerLoadingWithCrop(
    expensesSelector,
    actions => actions.fetchExpenses
)(ExpensesDashboard);
